"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceShareDialog = void 0;
var _react = require("react");
var _useUserSearch = require("@common/components/share/use-user-search");
var _useShareGrants = require("@common/components/share/use-share-grants");
var _resourceShareCopy = require("./resource-share-copy");
var _resourceShareAccessView = require("./resource-share-access-view");
var _shareDialogFrame = require("./share-dialog-frame");
var _iconButtonActivation = require("@common/components/confirmation-dialog/icon-button-activation");
var _resourceShareCollaboratorsView = require("./resource-share-collaborators-view");
var _teamInviteConfirmationDialog = require("./team-invite-confirmation-dialog");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["viewportGutterPx"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var CONFIRMATION_VISIBLE_MS = 4000;
function granteesWithAccess(owner, sharedUsers, sharedTeams) {
  var collaborators = sharedUsers.filter(function (user) {
    return user.userId !== (owner === null || owner === void 0 ? void 0 : owner.userId);
  }).map(_resourceShareCopy.userGrantee);
  var people = owner ? [(0, _resourceShareCopy.userGrantee)(owner)].concat(_toConsumableArray(collaborators)) : collaborators;
  return [].concat(_toConsumableArray(people), _toConsumableArray(sharedTeams.map(_resourceShareCopy.teamGrantee)));
}
function granteeKeysOf(userIds, teamIds) {
  return new Set([].concat(_toConsumableArray(_toConsumableArray(userIds).map(_resourceShareCopy.userGranteeKey)), _toConsumableArray(_toConsumableArray(teamIds).map(_resourceShareCopy.teamGranteeKey))));
}
var ResourceShareDialogContent = function ResourceShareDialogContent(_ref) {
  var _ref2;
  var resourceId = _ref.resourceId,
    resourceName = _ref.resourceName,
    resourceKind = _ref.resourceKind,
    currentUser = _ref.currentUser,
    owner = _ref.owner,
    searchUsers = _ref.searchUsers,
    shareableTeams = _ref.shareableTeams,
    canManageShares = _ref.canManageShares,
    track = _ref.track,
    viewerOnly = _ref.viewerOnly,
    copyLink = _ref.copyLink,
    initialSharedUsers = _ref.initialSharedUsers,
    initialSharedTeams = _ref.initialSharedTeams,
    shareLoadError = _ref.shareLoadError,
    onAddUser = _ref.onAddUser,
    onRemoveUser = _ref.onRemoveUser,
    onAddTeam = _ref.onAddTeam,
    onRemoveTeam = _ref.onRemoveTeam,
    onClose = _ref.onClose;
  var userSearch = (0, _useUserSearch.useUserSearch)(searchUsers);
  var grants = (0, _useShareGrants.useShareGrants)({
    initialSharedUsers: initialSharedUsers,
    initialSharedTeams: initialSharedTeams,
    onAddUser: onAddUser,
    onRemoveUser: onRemoveUser,
    onAddTeam: onAddTeam,
    onRemoveTeam: onRemoveTeam
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowingCollaborators = _useState2[0],
    setIsShowingCollaborators = _useState2[1];
  var isSendingInvitesRef = (0, _react.useRef)(false);
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    invitees = _useState4[0],
    setInvitees = _useState4[1];
  var _useState5 = (0, _react.useState)("viewer"),
    _useState6 = _slicedToArray(_useState5, 2),
    inviteRole = _useState6[0],
    setInviteRole = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    confirmation = _useState8[0],
    setConfirmation = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isConfirmingTeamInvite = _useState0[0],
    setIsConfirmingTeamInvite = _useState0[1];
  (0, _react.useEffect)(function () {
    if (!confirmation) return;
    var timeout = setTimeout(function () {
      return setConfirmation(null);
    }, CONFIRMATION_VISIBLE_MS);
    return function () {
      return clearTimeout(timeout);
    };
  }, [confirmation]);
  (0, _react.useEffect)(function () {
    track("resource_share_dialog_opened", {
      resourceId: resourceId,
      resourceKind: resourceKind
    });
  }, [track, resourceId, resourceKind]);
  var grantees = (0, _react.useMemo)(function () {
    return granteesWithAccess(owner, grants.sharedUsers, grants.sharedTeams);
  }, [owner, grants.sharedUsers, grants.sharedTeams]);
  var searchResults = (0, _react.useMemo)(function () {
    var unavailableKeys = new Set([].concat(_toConsumableArray(grantees), _toConsumableArray(invitees)).map(_resourceShareCopy.granteeKey));
    return userSearch.results.map(_resourceShareCopy.userGrantee).filter(function (grantee) {
      return !unavailableKeys.has((0, _resourceShareCopy.granteeKey)(grantee));
    });
  }, [userSearch.results, grantees, invitees]);
  var invitableTeams = (0, _react.useMemo)(function () {
    var sharedTeamIds = new Set(grants.sharedTeams.map(function (team) {
      return team.teamId;
    }));
    return shareableTeams.filter(function (team) {
      return !sharedTeamIds.has(team.teamId);
    });
  }, [shareableTeams, grants.sharedTeams]);
  var updatingKeys = (0, _react.useMemo)(function () {
    return granteeKeysOf(grants.addingUserIds, grants.addingTeamIds);
  }, [grants.addingUserIds, grants.addingTeamIds]);
  var removingKeys = (0, _react.useMemo)(function () {
    return granteeKeysOf(grants.removingUserIds, grants.removingTeamIds);
  }, [grants.removingUserIds, grants.removingTeamIds]);
  function changeQuery(nextQuery) {
    grants.clearError();
    userSearch.setQuery(nextQuery);
  }
  function addInvitee(grantee) {
    setInvitees(function (previous) {
      return [].concat(_toConsumableArray(previous), [grantee]);
    });
    userSearch.setQuery("");
    track("resource_share_invitee_selected", {
      resourceId: resourceId,
      resourceKind: resourceKind,
      granteeKind: grantee.kind
    });
  }
  function removeInvitee(grantee) {
    setInvitees(function (previous) {
      return previous.filter(function (invitee) {
        return (0, _resourceShareCopy.granteeKey)(invitee) !== (0, _resourceShareCopy.granteeKey)(grantee);
      });
    });
  }
  function cancelInvite() {
    setInvitees([]);
    userSearch.setQuery("");
  }
  function grant(grantee, role) {
    return grantee.kind === "user" ? grants.addUser(grantee.user, role) : grants.addTeam(grantee.team, role);
  }
  var invitedTeams = invitees.flatMap(function (invitee) {
    return invitee.kind === "team" ? [invitee.team] : [];
  });
  function requestInvites() {
    if (invitedTeams.length > 0) setIsConfirmingTeamInvite(true);else void sendInvites();
  }
  function confirmTeamInvite() {
    setIsConfirmingTeamInvite(false);
    void sendInvites();
  }
  function sendInvites() {
    return _sendInvites.apply(this, arguments);
  }
  function _sendInvites() {
    _sendInvites = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var results, invited, teamCount;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!isSendingInvitesRef.current) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            isSendingInvitesRef.current = true;
            _context.n = 2;
            return Promise.all(invitees.map(function (invitee) {
              return grant(invitee, inviteRole);
            }));
          case 2:
            results = _context.v;
            isSendingInvitesRef.current = false;
            invited = invitees.filter(function (_, index) {
              return results[index];
            });
            setInvitees(function (previous) {
              return previous.filter(function (invitee) {
                return !invited.includes(invitee);
              });
            });
            if (!(invited.length === 0)) {
              _context.n = 3;
              break;
            }
            return _context.a(2);
          case 3:
            teamCount = invited.filter(function (invitee) {
              return invitee.kind === "team";
            }).length;
            track("resource_share_invites_sent", {
              resourceId: resourceId,
              resourceKind: resourceKind,
              inviteeCount: invited.length,
              teamCount: teamCount,
              role: inviteRole
            });
            setConfirmation((0, _resourceShareCopy.sharedWithConfirmation)(resourceName, invited));
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _sendInvites.apply(this, arguments);
  }
  function changeCollaboratorRole(_x, _x2) {
    return _changeCollaboratorRole.apply(this, arguments);
  }
  function _changeCollaboratorRole() {
    _changeCollaboratorRole = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(grantee, role) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return grant(grantee, role);
          case 1:
            if (_context2.v) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            track("resource_share_permission_changed", {
              resourceId: resourceId,
              resourceKind: resourceKind,
              role: role,
              granteeKind: grantee.kind
            });
            setConfirmation((0, _resourceShareCopy.permissionChangedConfirmation)(grantee, role));
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _changeCollaboratorRole.apply(this, arguments);
  }
  function removeCollaborator(_x3) {
    return _removeCollaborator.apply(this, arguments);
  }
  function _removeCollaborator() {
    _removeCollaborator = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(grantee) {
      var removed, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (!(grantee.kind === "user")) {
              _context3.n = 2;
              break;
            }
            _context3.n = 1;
            return grants.removeUser(grantee.user);
          case 1:
            _t = _context3.v;
            _context3.n = 4;
            break;
          case 2:
            _context3.n = 3;
            return grants.removeTeam(grantee.team);
          case 3:
            _t = _context3.v;
          case 4:
            removed = _t;
            if (removed) {
              _context3.n = 5;
              break;
            }
            return _context3.a(2, false);
          case 5:
            track("resource_share_collaborator_removed", {
              resourceId: resourceId,
              resourceKind: resourceKind,
              granteeKind: grantee.kind
            });
            setConfirmation((0, _resourceShareCopy.removedCollaboratorConfirmation)(grantee));
            return _context3.a(2, true);
        }
      }, _callee3);
    }));
    return _removeCollaborator.apply(this, arguments);
  }
  var closeIcon = (0, _iconButtonActivation.closeIconButton)(onClose);
  function showCollaborators() {
    track("resource_share_collaborators_opened", {
      resourceId: resourceId,
      resourceKind: resourceKind
    });
    setIsShowingCollaborators(true);
  }
  if (isShowingCollaborators) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_resourceShareCollaboratorsView.ResourceShareCollaboratorsView, {
      grantees: grantees,
      owner: owner,
      currentUser: currentUser,
      resourceName: resourceName,
      resourceKind: resourceKind,
      canManageShares: canManageShares,
      viewerOnly: viewerOnly,
      updatingKeys: updatingKeys,
      removingKeys: removingKeys,
      error: grants.error,
      confirmation: confirmation,
      onChangeRole: changeCollaboratorRole,
      onRemoveCollaborator: removeCollaborator,
      onClearError: grants.clearError,
      onBack: function onBack() {
        return setIsShowingCollaborators(false);
      },
      closeIcon: closeIcon
    });
  }
  var teamInviteConfirmation = isConfirmingTeamInvite ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_teamInviteConfirmationDialog.TeamInviteConfirmationDialog, {
    teams: invitedTeams,
    role: inviteRole,
    resourceName: resourceName,
    resourceKind: resourceKind,
    onCancel: function onCancel() {
      return setIsConfirmingTeamInvite(false);
    },
    onConfirm: confirmTeamInvite
  }) : null;
  var accessView = /*#__PURE__*/(0, _jsxRuntime.jsx)(_resourceShareAccessView.ResourceShareAccessView, {
    resourceName: resourceName,
    resourceKind: resourceKind,
    currentUser: currentUser,
    grantees: grantees,
    isLoading: initialSharedUsers === undefined && shareLoadError === null,
    canManageShares: canManageShares && initialSharedUsers !== undefined,
    query: userSearch.query,
    searchResults: searchResults,
    invitableTeams: invitableTeams,
    isSearching: userSearch.loading,
    error: (_ref2 = shareLoadError !== null && shareLoadError !== void 0 ? shareLoadError : grants.error) !== null && _ref2 !== void 0 ? _ref2 : userSearch.error,
    confirmation: confirmation,
    invitees: invitees,
    inviteRole: inviteRole,
    isInviting: updatingKeys.size > 0,
    viewerOnly: viewerOnly,
    copyLink: copyLink,
    onQueryChange: changeQuery,
    onAddInvitee: addInvitee,
    onRemoveInvitee: removeInvitee,
    onInviteRoleChange: setInviteRole,
    onCancelInvite: cancelInvite,
    onSendInvites: requestInvites,
    onShowCollaborators: showCollaborators,
    onTeamPickerOpen: function onTeamPickerOpen() {
      return track("resource_share_team_picker_opened", {
        resourceId: resourceId,
        resourceKind: resourceKind
      });
    },
    closeIcon: closeIcon
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [accessView, teamInviteConfirmation]
  });
};
var ResourceShareDialog = exports.ResourceShareDialog = function ResourceShareDialog(_ref3) {
  var viewportGutterPx = _ref3.viewportGutterPx,
    contentProps = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareDialogFrame.ShareDialogFrame, {
    viewportGutterPx: viewportGutterPx,
    "data-sentry-element": "ShareDialogFrame",
    "data-sentry-component": "ResourceShareDialog",
    "data-sentry-source-file": "resource-share-dialog.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ResourceShareDialogContent, _objectSpread(_objectSpread({}, contentProps), {}, {
      "data-sentry-element": "ResourceShareDialogContent",
      "data-sentry-source-file": "resource-share-dialog.tsx"
    }))
  });
};